import { render, staticRenderFns } from "./GinViewadjust.vue?vue&type=template&id=24dfb91c&scoped=true"
import script from "./GinViewadjust.vue?vue&type=script&lang=js"
export * from "./GinViewadjust.vue?vue&type=script&lang=js"
import style0 from "./GinViewadjust.vue?vue&type=style&index=0&id=24dfb91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfb91c",
  null
  
)

export default component.exports